import styles from './Avatar.module.css'

interface AvatarProps {
  name: string
  src?: string
  size?: 'sm' | 'md' | 'lg'
  className?: string
}

export function Avatar({ name, src, size = 'md', className }: AvatarProps) {
  const initials = name
    .split(' ')
    .map((n) => n[0])
    .join('')
    .slice(0, 2)
    .toUpperCase()

  if (src) {
    return (
      <img
        src={src}
        alt={name}
        className={[styles.avatar, styles[size], className]
          .filter(Boolean)
          .join(' ')}
      />
    )
  }

  return (
    <div
      className={[styles.avatar, styles.initials, styles[size], className]
        .filter(Boolean)
        .join(' ')}
      aria-hidden="true"
    >
      {initials}
    </div>
  )
}
